import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormButton } from '@app/core/components/form-field-button/form-field-button.component';
import { DataTaskService } from '@app/core/services/data-task.service';
import { TranslateEditDialogComponent, TranslateEditDialogData } from '@app/modal/translate-edit-dialog/translate-edit-dialog.component';
import { Subject, switchMap } from 'rxjs';

@Component({
    selector: 'tt-p2-setting-edit-form',
    templateUrl: './p2-setting-edit-form.component.html',
    styleUrls: ['./p2-setting-edit-form.component.css'],
})
export class P2SettingEditFormComponent implements OnChanges {
    @Input()
    public params: { p2_setting_keyno: string } = { p2_setting_keyno: '0' };

    @Output()
    public submit = new EventEmitter<{ p2_setting_keyno: string }>();

    public get?: P2SettingEditGet;

    public settingNameButtons: FormButton[] = [{ id: 'translate', icon: 'far fa-language', type: 'primary', onClick: () => this.openTranslationDialog() }];

    public saving = false;

    private loadSubject = new Subject<{ p2_setting_keyno: string }>();

    constructor(private datatask: DataTaskService, private dialog: MatDialog) {
        this.loadSubject.pipe(switchMap((params: any) => this.getP2SettingEdit(params))).subscribe({ next: (setting) => (this.get = setting) });
    }

    public async save() {
        if (!!this.get) {
            this.saving = true;

            try {
                const data = await this.saveP2SettingEdit(this.get);
                this.submit.emit({ p2_setting_keyno: data.p2_setting_keyno });
            } catch (error) {
                console.error(error);
            } finally {
                this.saving = false;
            }
        }
    }

    private openTranslationDialog = async () => {
        if (!!this.get && this.get.p2_setting_keyno > '0') {
            const edits = await this.datatask.Post(61, { word_id: this.get.word_id });
            const dialogRef = this.dialog.open(TranslateEditDialogComponent, {
                width: '120rem',
                maxWidth: '95vw',
                height: '80vh',
                data: <TranslateEditDialogData<any>>{
                    heading: `(${this.get.p2_setting_keyno}) ${this.get.word_id}`,
                    textToTranslate: this.get.setting_name,
                    edits: edits,
                    save: async (data) => {
                        await this.datatask.Post(62, { wordlang_names: data.edits });
                        this.loadGet();
                        dialogRef.close();
                    },
                },
            });
        }
    };

    private async loadGet() {
        delete this.get;
        this.loadSubject.next(this.params);
    }

    private async getP2SettingEdit(params: { p2_setting_keyno: string }): Promise<P2SettingEditGet> {
        return (await this.datatask.Post(7, params))[0];
    }

    private async saveP2SettingEdit(get: P2SettingEditGet): Promise<P2SettingEditSave> {
        return (await this.datatask.Post(8, get))[0];
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['params'] && typeof changes['params'].currentValue === 'object' && 'p2_setting_keyno' in changes['params'].currentValue) {
            this.loadGet();
        }
    }
}

interface P2SettingEditGet {
    p2_setting_keyno: string;
    word_id: string;
    input_type: string;
    default_value: string;
    choicedata: string;
    setting_name: string;
}

interface P2SettingEditSave {
    iserror: '1' | '0';
    message: string;
    p2_setting_keyno: string;
}
